import { useEffect, useState } from 'react'

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

function getInitialMotionState() {
  if (typeof window === 'undefined') return true
  return !window.matchMedia(REDUCED_MOTION_QUERY).matches
}

export function useMotionPreference() {
  const [motionEnabled, setMotionEnabled] = useState(getInitialMotionState)

  useEffect(() => {
    const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY)

    const handleChange = (event: MediaQueryListEvent) => {
      setMotionEnabled(!event.matches)
    }

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return { motionEnabled }
}
